function DiscussNoti() {
  return (
    <p
      className={`px-6 pt-[64px] pb-9 text-gray50 self-stretch justify-start text-[12px] font-[400] font-['Pretendard'] leading-[21px]`}
    >
      본 콘텐츠는 Chat-GPT 및 Perplexity 기반 인공지능 모델을 활용해
      생성되었습니다. 투자 판단에 참고가 될 수 있도록 구성되었으나, 정보의
      정확성과 시의성, 완전성이 항상 보장되지는 않을 수 있습니다. 실제 투자
      결정은 본인의 판단과 책임하에 이루어져야 하며, 당사는 이에 따른 손익에
      책임지지 않습니다.
    </p>
  );
}

export default DiscussNoti;
